/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Status_ForbiddenInputs */

const en_pol_status_forbidden = /** @type {(inputs: Pol_Status_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not allowed`)
};

const id_pol_status_forbidden = /** @type {(inputs: Pol_Status_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak diizinkan`)
};

/**
* | output |
* | --- |
* | "Not allowed" |
*
* @param {Pol_Status_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_status_forbidden = /** @type {((inputs?: Pol_Status_ForbiddenInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Status_ForbiddenInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_status_forbidden(inputs)
	return en_pol_status_forbidden(inputs)
});